document.addEventListener("DOMContentLoaded", function () {
    const itemsPerPage = 24;

    // Function to show items for the given page
    function showItemsForPage(page) {
        const gridItems = document.querySelectorAll("#product-grid .grid__item");
        const totalItems = gridItems.length;

        const startIndex = (page - 1) * itemsPerPage; // Zero-based index
        const endIndex = Math.min(page * itemsPerPage, totalItems); // Clamp to total items

        gridItems.forEach((item, index) => {
            if (index >= startIndex && index < endIndex) {
                item.style.display = "block"; // Show items in the range
            } else {
                item.style.display = "none"; // Hide items outside the range
            }
        });

        console.log(`Showing items ${startIndex + 1} to ${endIndex}`);
    }

    // Function to update the URL with the current custom_page parameter
    function updateUrlParameter(page) {
        const url = new URL(window.location);
        url.searchParams.set("custom_page", page);
        window.history.replaceState({}, "", url); // Update the URL without reloading
    }

    // Function to highlight the active pagination link
    function highlightActivePage(page) {
        const paginationItems = document.querySelectorAll(".pagination__item");
        paginationItems.forEach((item) => {
            const itemPage = parseInt(item.getAttribute("data-page"));
            if (itemPage === page) {
                item.classList.add("pagination__item--current");
            } else {
                item.classList.remove("pagination__item--current");
            }
        });
    }

    // Event delegation to handle pagination clicks
    // document.addEventListener("click", function (e) {
    //     const target = e.target.closest(".pagination__item");
    //     if (!target) return;

    //     e.preventDefault(); // Prevent default link behavior

    //     const page = parseInt(target.getAttribute("data-page"));
    //     if (!page) {
    //         console.warn("Invalid page number:", page);
    //         return;
    //     }

    //     // Update URL, show items, and highlight the active page
    //     updateUrlParameter(page);
    //     showItemsForPage(page);
    //     highlightActivePage(page);

    //     // Scroll to the top of the page
    //     window.scrollTo({
    //         top: 0,
    //         behavior: "smooth", // Smooth scrolling effect
    //     });
    // });

    // Integrate with facets.js renderPage
    const originalRenderPage = FacetFiltersForm.renderPage;
    // FacetFiltersForm.renderPage = function (searchParams, event, updateURLHash = true) {
    //     // Call the original renderPage function
    //     originalRenderPage.call(this, searchParams, event, updateURLHash);

    //     // Reapply pagination logic after re-rendering
    //     const currentCustomPage = parseInt(new URLSearchParams(window.location.search).get("custom_page")) || 1;
    //     showItemsForPage(currentCustomPage);
    //     highlightActivePage(currentCustomPage);
    // };

    // // On page load, get the current custom_page from the URL
    // const urlParams = new URLSearchParams(window.location.search);
    // const customPage = parseInt(urlParams.get("custom_page")) || 1;

    // // Show the items for the current page and highlight the active link
    // showItemsForPage(customPage);
    // highlightActivePage(customPage);
});
